export default __webpack_public_path__ + "static/media/Startup.5ecdcbf5.png";